import {Component, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-live-agent',
  templateUrl: './live-agent.component.html'
})
export class LiveAgentComponent implements OnInit {


  get validLiveAgentKeys(): boolean {
    return !!environment.liveAgentSalesforceUrl &&
      !!environment.liveAgentCommunityUrl &&
      !!environment.liveAgentGslbBaseURL &&
      !!environment.liveAgentOrgId &&
      !!environment.liveAgentContentUrl &&
      !!environment.liveAgentDeploymentId &&
      !!environment.liveAgentButtonId &&
      !!environment.liveAgentUrl;
  }

  constructor() {
  }

  ngOnInit(): void {
    this.initESW();
  }

  initESW(): void {


    if (!this.validLiveAgentKeys) {
      return;
    }

    // tslint:disable-next-line: no-string-literal
    const embeddedSvc = window['embedded_svc'];

    if (!environment.salesforceLiveAgentEnabled || environment.salesforceLiveAgentEnabled === 'false' || !embeddedSvc) {
      return;
    }

    embeddedSvc.settings.displayHelpButton = true;
    embeddedSvc.settings.language = '';
    embeddedSvc.settings.defaultMinimizedText = 'Chat';
    embeddedSvc.settings.offlineSupportMinimizedText = 'Contact us';
    embeddedSvc.settings.extraPrechatFormDetails = [
      {label: 'Email', transcriptFields: ['Email__c']},
      {label: 'Are you an existing Yopa Customer?', transcriptFields: ['Existing_Customer__c']}
    ];
    embeddedSvc.settings.enabledFeatures = ['LiveAgent'];
    embeddedSvc.settings.entryFeature = 'LiveAgent';
    embeddedSvc.settings.extraPrechatInfo = [{
      entityFieldMaps: [{
        doCreate: false,
        doFind: true,
        fieldName: 'LastName',
        isExactMatch: false,
        label: 'Last Name'
      }, {
        doCreate: false,
        doFind: true,
        fieldName: 'FirstName',
        isExactMatch: false,
        label: 'First Name'
      }, {
        doCreate: false,
        doFind: true,
        fieldName: 'Email',
        isExactMatch: true,
        label: 'Email'
      }],
      entityName: 'Contact'
    }];

    embeddedSvc.addEventHandler('onSettingsCallCompleted', (data) => {
      this.showChat(data);
    });

    embeddedSvc.addEventHandler('onAvailability', (data) => {
      this.showChat(data);
    });

    embeddedSvc.init(
      environment.liveAgentSalesforceUrl,
      environment.liveAgentCommunityUrl,
      environment.liveAgentGslbBaseURL,
      environment.liveAgentOrgId,
      'Live_Chat',
      {
        baseLiveAgentContentURL: environment.liveAgentContentUrl,
        deploymentId: environment.liveAgentDeploymentId,
        buttonId: environment.liveAgentButtonId,
        baseLiveAgentURL: environment.liveAgentUrl,
        eswLiveAgentDevName: 'Live_Chat',
        isOfflineSupportEnabled: true
      }
    );
  }

  showChat(data): void {
    if (data && data.isAgentAvailable && this.validLiveAgentKeys) {
      document.getElementsByClassName('embeddedServiceHelpButton')[0].classList.add('is-online');
    } else {
      const chatWindow = document.getElementsByClassName('embeddedServiceSidebar')[0];
      if (chatWindow) {
        chatWindow.classList.add('hidden');
      }
    }
  }

}
